import React from 'react';
import { Instagram, Mail } from 'lucide-react';

export const Footer = () => (
  <footer className="bg-[#6B5845] text-white py-12">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid md:grid-cols-3 gap-8 mb-8">
        <div>
          <img
            src="https://customer-assets.emergentagent.com/job_6bd1bdb6-929b-492c-804f-03ddd69ea176/artifacts/udp9h1gt_SHOT%20TO%20THE%20NINES.png"
            alt="Shot to the Nines"
            className="h-20 mb-4 brightness-0 invert"
          />
          <p className="text-sm opacity-80">Handcrafted vintage-style photo booth experiences</p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm opacity-80">
            <li><a href="#about" className="hover:text-[#C9A961] transition-colors">Our Story</a></li>
            <li><a href="#booth" className="hover:text-[#C9A961] transition-colors">The Booth</a></li>
            <li><a href="#packages" className="hover:text-[#C9A961] transition-colors">Packages</a></li>
            <li><a href="#gallery" className="hover:text-[#C9A961] transition-colors">Gallery</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">Connect</h4>
          <ul className="space-y-2 text-sm opacity-80">
            <li>
              <a href="https://instagram.com/shot2thenines" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A961] transition-colors flex items-center gap-2">
                <Instagram className="w-4 h-4" /> @shot2thenines
              </a>
            </li>
            <li>
              <a href="mailto:shot2thenines@gmail.com" className="hover:text-[#C9A961] transition-colors flex items-center gap-2">
                <Mail className="w-4 h-4" /> shot2thenines@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/20 pt-8 text-center text-sm opacity-70">
        <p>&copy; 2026 Shot to the Nines. Handcrafted with heart in Brisbane & Gold Coast.</p>
      </div>
    </div>
  </footer>
);
